import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { LivePreviewContext } from '../components/template-details';
import getUserAuthorizationStatus from '../modules/user/selectors/user-authorization-status';
import getSiteIdToRecreate from '../modules/sites/selectors/get-site-id-recreate';
import getSiteIdToSwitch from '../modules/sites/selectors/site-id-to-switch-template';
import HeaderDetailPage from '../components/header-detail-page';
import trackers from '../modules/analytics/segment/trackers';
import { SiteSetupContext } from '../modules/site-setup/helpers/site-setup-context';
import useOnTemplateSelect from '../modules/site-setup/hooks/use-on-template-select';
import constants from '../modules/site-setup/constants';

const { trackLivePreviewBackClicked, trackLivePreviewDeviceClicked } = trackers;
const { triggerIds } = constants;

const HeaderDetailPageContainer = () => {
  const navigate = useNavigate();
  const params = useParams();

  const isUserAuthenticated = useSelector(getUserAuthorizationStatus);
  const siteIdToRecreate = useSelector(getSiteIdToRecreate);
  const siteIdToSwitch = useSelector(getSiteIdToSwitch);
  const siteId = siteIdToRecreate || siteIdToSwitch || null;
  const { templateSlug } = params;
  const context = useContext(SiteSetupContext);
  const { getArchetype } = context;

  const isPreloader = isUserAuthenticated && !siteIdToSwitch;

  const onTemplateSelect = useOnTemplateSelect({
    isTrackEventsAsync: true,
  });

  const onUseThisTemplate = useCallback(
    () => onTemplateSelect(templateSlug, triggerIds.TEMPLATE),
    [onTemplateSelect, templateSlug]
  );

  const onBackButtonClick = useCallback(() => {
    trackLivePreviewBackClicked({ siteId, templateBuildSlug: templateSlug });
    navigate(-1);
  }, [siteId, templateSlug, navigate]);

  const onToggleMode = useCallback(
    (prevMode, newMode, toggleMode) => {
      if (prevMode !== newMode) {
        trackLivePreviewDeviceClicked({
          siteId,
          templateBuildSlug: templateSlug,
          typeId: newMode,
        });
      }

      toggleMode(newMode);
    },
    [siteId, templateSlug]
  );

  return (
    <LivePreviewContext.Consumer>
      {({ mode, toggleMode }) => (
        <HeaderDetailPage
          mode={mode}
          archetype={getArchetype()}
          toggleMode={(newMode) => {
            onToggleMode(mode, newMode, toggleMode);
          }}
          isPreloader={isPreloader}
          onUseThisTemplate={onUseThisTemplate}
          onBackButtonClick={onBackButtonClick}
        />
      )}
    </LivePreviewContext.Consumer>
  );
};

export default HeaderDetailPageContainer;
